import React, { Component } from "react";
import BrandingLogo from "../components/common/BrandingLogo";
import { navLinks } from "../services/navLinkService";
import ListGroup from "./navListGroup";
import { getCurrentUser } from "../services/userService";
import NetworkStatus from "../components/common/networkStatus";
import NotificationBell from "../platform/notifications/NotificationBell";
import { applyTheme, getPreferredTheme, setTheme } from "../services/themeService";

function userInitials(name) {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

class NavBar extends Component {
  state = {
    links: [],
    selectedLink: null,
    loading: true,
    error: null,
    user: null,
    showNav: false,
    theme: "light",
  };

  async getCurrentUser() {
    try {
      const { data: user } = await getCurrentUser();
      this.setState({ loading: false, user });
    } catch (error) {
      this.setState({ error: "Failed to load user data", loading: false });
    }
  }

  async componentDidMount() {
    this.setState({ links: navLinks, selectedLink: {} });
    this.getCurrentUser();
    const theme = getPreferredTheme();
    applyTheme(theme);
    this.setState({ theme });
  }

  handleLinkSelect = (link) => {
    this.setState({ selectedLink: link });
  };

  toggleNav = () => {
    this.setState({ showNav: !this.state.showNav });
  };

  toggleTheme = () => {
    const theme = this.state.theme === "dark" ? "light" : "dark";
    setTheme(theme);
    this.setState({ theme });
  };

  render() {
    const { user, loading, error } = this.state;
    const name = user?.Contact?.fullname || user?.name;
    const displayName = loading ? "…" : error ? "—" : name || "User";

    return (
      <React.Fragment>
        <nav className="navbar navbar-expand-md mboss-topbar sticky-top d-flex align-items-center">
          <a className="navbar-brand mb-0" href="/client/#">
            <BrandingLogo colorTheme={this.state.theme} maxHeight="36px" />
          </a>

          <button
            onClick={this.toggleNav}
            className="navbar-toggler d-flex justify-content-center align-items-center border-0 bg-transparent d-block d-md-none ml-auto"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNavAltMarkup"
            aria-controls="navbarNavAltMarkup"
            aria-expanded={this.state.showNav ? "true" : "false"}
            aria-label="Toggle navigation"
          >
            <i className={this.state.showNav ? "fa fa-times" : "fa fa-bars"} />
          </button>

          <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
            <div className="container-fluid d-block d-md-none">
              {user && (
                <button
                  type="button"
                  className="btn btn-link text-secondary pl-0"
                  onClick={this.props.onHelpOpen}
                >
                  <i className="fa fa-question-circle mr-2" /> Help
                </button>
              )}
              {user && (
                <nav className="nav-section-list nav-section-list--mobile" aria-label="Modules">
                  <ListGroup
                    items={this.state.links}
                    selectedItem={this.state.selectedLink}
                    onItemSelect={(link) => {
                      this.handleLinkSelect(link);
                      document.getElementById("navbarNavAltMarkup").classList.toggle("show");
                      this.setState({ showNav: !this.state.showNav });
                    }}
                  />
                </nav>
              )}
            </div>
          </div>

          <div className="navbar-actions ml-auto d-none d-md-flex">
            <div className="navbar-user-chip" title={error || name || undefined}>
              <span className="navbar-user-avatar" aria-hidden>
                {loading ? "…" : userInitials(name)}
              </span>
              <span className="navbar-user-name">{displayName}</span>
            </div>

            <div className="navbar-toolbar" role="toolbar" aria-label="Workspace tools">
              <NetworkStatus />
              {user && <NotificationBell />}
              <button
                type="button"
                className="navbar-icon-button"
                onClick={this.props.onHelpOpen}
                aria-label="Open help"
                title="Open help"
              >
                <i className="fa fa-question-circle" aria-hidden />
              </button>
              <button
                type="button"
                className="navbar-icon-button"
                onClick={this.toggleTheme}
                aria-label={
                  this.state.theme === "dark" ? "Switch to light mode" : "Switch to dark mode"
                }
                title={
                  this.state.theme === "dark" ? "Switch to light mode" : "Switch to dark mode"
                }
              >
                <i
                  className={this.state.theme === "dark" ? "fa fa-sun-o" : "fa fa-moon-o"}
                  aria-hidden
                />
              </button>
            </div>
          </div>
        </nav>
      </React.Fragment>
    );
  }
}

export default NavBar;
